"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const Send = props => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16,0 L0,5.81718752 L10.1828128,16 L16,0 Z M13.325,2.675 L9.5375,13.0921872 L6.8625,10.4171872 L10.9093752,5.09062496 L5.58281248,9.1375 L2.90781248,6.4625 L13.325,2.675 Z" }, void 0) }), void 0));
exports.SendIcon = (0, makeIcon_1.makeIcon)('send')(Send);
//# sourceMappingURL=Send.js.map